import {Form, Input, Space, Button, message, Spin, Row, Col, Divider, Card, Typography} from "antd";
import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import axios from 'axios';
import {CloseOutlined, SaveOutlined, CarOutlined} from '@ant-design/icons';
import {useTranslation} from "react-i18next";
import {parsePhoneNumberFromString, isValidPhoneNumber} from 'libphonenumber-js';
import GlobalSelect from "../../generales/GlobalSelect";

const { Title } = Typography;

export const Axios = axios.create({
    baseURL: process.env.REACT_APP_APPI_ADDRESS
});

const FormAddVehiculo = ({accion}) => {
    const headers = {
        'accept': '*/*',
        'Authorization': 'Bearer ' + sessionStorage.getItem('token'),
        'Content-Type': 'application/json',
    };

    const {t, i18n} = useTranslation();
    const [messageApi, contextHolder] = message.useMessage();
    const [spinning, setSpinning] = useState(false);
    const [spinTitle, setSpinTitle] = useState(t('global.processing_data'));
    const [title] = useState((accion === "mod") ? t('vehicle.edit_title') : t('vehicle.add_title'));
    const navigate = useNavigate();
    const {id} = useParams();
    const [form] = Form.useForm();
    const [repartidor, setRepartidor] = useState([]);
    const [estadoVehiculo, setEstadoVehiculo] = useState([]);
    const [tipoVehiculo, setTipoVehiculo] = useState([]);


    const validateEmail = (rule, value, callback) => {
        if (value) {
            const emailRegex = /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/;
            if (accion !== "pass" && !emailRegex.test(value)) {
                callback('Correo Inválido / Invalid email address');
            } else {
                callback();
            }
        }
    };

    // const validatePhoneNumber = (rule, value) => {
    //     if (!value) {
    //         return Promise.reject('El número de teléfono es obligatorio');
    //     }
    //
    //     // Usa parsePhoneNumberFromString para validar con distintos formatos
    //     const phoneNumberUS = parsePhoneNumberFromString(value, 'US');
    //     const phoneNumberCuba = parsePhoneNumberFromString(value, 'CU');
    //
    //     // Comprueba si el número es válido para EE. UU. o Cuba
    //     if ((phoneNumberUS && phoneNumberUS.isValid()) || (phoneNumberCuba && phoneNumberCuba.isValid())) {
    //         return Promise.resolve();
    //     }
    //
    //     return Promise.reject('Número de teléfono no válido para EE. UU. o Cuba');
    // };

    const cargarRepartidor = () => {
        setSpinning(true);
        let aux = [];
        // let start = 0;
        // let limit = 1000;

        Axios.post("mts/getUssers",
            {
                // "start": start,
                // "limit": limit,
                "filtros": [{
                    "idrol": 4
                }]
            },
            {
                headers: headers
            }
        ).then(response => {
            setSpinning(false);
            if (response.data.data.length > 0) {
                for (let i = 0; i < response.data.data.length; i++) {
                    aux.push({
                        id: response.data.data[i].idusuario,
                        // idrepartidor:response.data.data[i].idusuario,
                        nombre: response.data.data[i].fullname
                    });
                }
            }
            setRepartidor(aux);
        }).catch(error => {
            setSpinning(false);
            setRepartidor(aux);
        })
    };

    const cargarEstadoVehiculo = () => {
        setSpinning(true);
        let aux = [];
        // let start = 0;
        // let limit = 1000;

        Axios.post("sd/getEstadoVehiculo",
            {
                // "start": start,
                // "limit": limit,
                // "filtros":{
                //     "idrol": 4
                // }
            },
            {
                headers: headers
            }
        ).then(response => {
            setSpinning(false);
            if (response.data.data.length > 0) {
                for (let i = 0; i < response.data.data.length; i++) {
                    aux.push({
                        id: response.data.data[i].idestadovehiculo,
                        nombre: response.data.data[i].denominacion
                    });
                }
            }
            setEstadoVehiculo(aux);
        }).catch(error => {
            setSpinning(false);
            setEstadoVehiculo(aux);
        })
    };

    const cargarTipoVehiculo = () => {
        setSpinning(true);
        let aux = [];
        // let start = 0;
        // let limit = 1000;

        Axios.post("sd/getTipoVehiculo",
            {
                // "start": start,
                // "limit": limit,
                "filtros": {
                    "activo": 1
                }
            },
            {
                headers: headers
            }
        ).then(response => {
            setSpinning(false);
            if (response.data.data.length > 0) {
                for (let i = 0; i < response.data.data.length; i++) {
                    aux.push({
                        id: response.data.data[i].idtipovehiculo,
                        nombre: response.data.data[i].denominacion
                    });
                }
            }
            setTipoVehiculo(aux);
        }).catch(error => {
            setSpinning(false);
            setTipoVehiculo(aux);
        })
    };

    useEffect(() => {

        cargarRepartidor();
        cargarEstadoVehiculo();
        cargarTipoVehiculo();

        if (accion === "mod") {
            if (!sessionStorage.getItem('sessionDataStorage')) {
                navigate('/vehiculo');
            } else {
                let sessionDataStorage = JSON.parse(sessionStorage.getItem('sessionDataStorage'));
                form.setFieldsValue({
                    "marca": sessionDataStorage.marca,
                    "modelo": sessionDataStorage.modelo,
                    "matricula": sessionDataStorage.matricula,
                    "capacidad_carga": sessionDataStorage.capacidad_carga,
                    "longitud_carga": sessionDataStorage.longitud_carga,
                    "ancho_carga": sessionDataStorage.ancho_carga,
                    "altura_carga": sessionDataStorage.altura_carga,
                    "comentarios": sessionDataStorage.comentarios,
                    "idusuario": sessionDataStorage.idusuario,
                    "idestadovehiculo": sessionDataStorage.idestadovehiculo,
                    "idtipovehiculo": sessionDataStorage.idtipovehiculo,
                });
            }
        }
    }, []);

    const cancelar = () => {
        navigate('/vehiculo');
    };

    const onFinish = (values) => {
        values.idvehiculo = id;
        setSpinning(true);

        let message;

        if (accion === "add") {
            setSpinTitle(t('global.processing_data'));
            Axios.post("sd/addVehiculo", values, {headers})
                .then(response => {
                    setSpinning(false);
                    message = response.data.message;
                    if (response.data.success) {
                        messageApi.open({
                            type: 'success',
                            content: response.data.message,
                        });
                        setTimeout(messageApi.destroy, 3500);
                        navigate('/vehiculo');
                    } else {
                        messageApi.open({type: 'error', content: message});
                        setTimeout(messageApi.destroy, 3500);
                    }
                })
                .catch(() => {
                    setSpinning(false);
                    messageApi.open({type: 'error', content: message});
                    setTimeout(messageApi.destroy, 3500);
                });
        } else if (accion === "mod") {
            setSpinTitle(t('global.processing_data'));
            Axios.post("sd/updateVehiculo", values, {headers})
                .then(response => {
                    setSpinning(false);
                    message = response.data.message;
                    if (response.data.success) {
                        messageApi.open({
                            type: 'success',
                            content: response.data.message,
                        });
                        setTimeout(messageApi.destroy, 2500);
                        navigate('/vehiculo');
                    } else {
                        messageApi.open({type: 'error', content: message});
                        setTimeout(messageApi.destroy, 2500);
                    }
                })
                .catch(() => {
                    setSpinning(false);
                    messageApi.open({type: 'error', content: message});
                    setTimeout(messageApi.destroy, 2500);
                });
        }
    };

    return (
        <div style={{
            minHeight: "100vh",
            background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
            padding: "24px"
        }}>
            <Spin spinning={spinning} tip={spinTitle} size={"large"}>
                <div style={{
                    maxWidth: "1200px",
                    margin: "0 auto"
                }}>
                    {/* Header */}
                    <div style={{
                        background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                        borderRadius: '12px 12px 0 0',
                        padding: '24px',
                        color: 'white'
                    }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '16px'
                        }}>
                            <div style={{
                                background: 'rgba(255,255,255,0.2)',
                                borderRadius: '50%',
                                width: '48px',
                                height: '48px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '20px'
                            }}>
                                <CarOutlined />
                            </div>
                            <div>
                                <Title level={2} style={{
                                    color: 'white',
                                    margin: 0,
                                    fontSize: '24px'
                                }}>
                                    {title}
                                </Title>
                                <p style={{
                                    color: 'rgba(255,255,255,0.8)',
                                    margin: 0,
                                    fontSize: '14px'
                                }}>
                                    {accion === "mod" ? "Modifica los datos del vehículo" : "Completa los datos del nuevo vehículo"}
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Form Content */}
                    <Card style={{
                        borderRadius: '0 0 12px 12px',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                        border: 'none'
                    }}>
                        {contextHolder}

                        <Form
                            form={form}
                            autoComplete="on"
                            onFinish={onFinish}
                            layout="vertical"
                            initialValues={{activo: 1}}
                        >
                            {/* Vehicle Basic Information Section */}
                            <div style={{
                                background: 'linear-gradient(135deg, #f8f9fc 0%, #e8ebf7 100%)',
                                borderRadius: '12px',
                                padding: '20px',
                                marginBottom: '24px',
                                border: '1px solid #e0e6ff'
                            }}>
                                <Title level={4} style={{
                                    color: '#253289',
                                    marginBottom: '16px',
                                    fontSize: '16px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                }}>
                                    🚗 Información Básica del Vehículo
                                </Title>

                                <Row gutter={16}>
                                    <Col xs={24} sm={8}>
                                        <Form.Item
                                            name="marca"
                                            label={t('vehicle.marca')}
                                            rules={[{required: true, message: 'Por favor debe poner la marca!'}]}
                                        >
                                            <Input
                                                tabIndex={1}
                                                placeholder="Ej: Toyota, Ford, Mercedes..."
                                                style={{ height: '40px' }}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={8}>
                                        <Form.Item
                                            name="modelo"
                                            label={t('vehicle.modelo')}
                                            rules={[{required: true, message: 'Por favor debe poner el modelo!'}]}
                                        >
                                            <Input
                                                tabIndex={2}
                                                placeholder="Ej: Hilux, Transit, Sprinter..."
                                                style={{ height: '40px' }}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={8}>
                                        <Form.Item
                                            name="matricula"
                                            label={t('vehicle.matricula')}
                                            rules={[{required: true, message: 'Por favor debe poner la matricula!'}]}
                                        >
                                            <Input
                                                tabIndex={3}
                                                placeholder="Ej: ABC-1234"
                                                style={{ height: '40px' }}
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </div>

                            {/* Technical Specifications Section */}
                            <div style={{
                                background: 'linear-gradient(135deg, #f8f9fc 0%, #e8ebf7 100%)',
                                borderRadius: '12px',
                                padding: '20px',
                                marginBottom: '24px',
                                border: '1px solid #e0e6ff'
                            }}>
                                <Title level={4} style={{
                                    color: '#253289',
                                    marginBottom: '16px',
                                    fontSize: '16px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                }}>
                                    📏 {t('vehicle.caracteristicas_tecnicas')}
                                </Title>

                                <Row gutter={16}>
                                <Col xs={24} sm={8}>
                                    <Form.Item
                                        name="idtipovehiculo"
                                        label={t('vehicle.tipo_vehiculo')}
                                        rules={[{
                                            required: true,
                                            message: 'Por favor debe seleccionar el tipo de vehículo!'
                                        }]}
                                    >
                                        <GlobalSelect
                                            loading={spinning}
                                            valueName={'idtipovehiculo'}
                                            data={tipoVehiculo}
                                            tabIndex={4}
                                            style={{ height: '40px' }}
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        name="ancho_carga"
                                        label={t('vehicle.ancho_carga')}
                                        rules={[{required: true, message: 'Por favor debe poner el ancho de carga!'},
                                            {
                                                pattern: /^\d+(\.\d+)?$/,
                                                message: 'Solo se permiten números enteros o con comas!',
                                            }]}
                                    >
                                        <Input
                                            tabIndex={6}
                                            placeholder="Ej: 2.5"
                                            style={{ height: '40px' }}
                                            onKeyPress={(event) => {
                                                const keyCode = event.which || event.keyCode;
                                                const char = String.fromCharCode(keyCode);
                                                const value = event.target.value;

                                                if (!/[0-9.]/.test(char) || (char === '.' && value.includes('.'))) {
                                                    event.preventDefault();
                                                }
                                            }}
                                        />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={8}>
                                    <Form.Item
                                        name="capacidad_carga"
                                        label={t('vehicle.capacidad_carga')}
                                        rules={[
                                            {required: true, message: 'Por favor debe poner la capacidad de carga!'},
                                            {
                                                pattern: /^\d+(\.\d+)?$/,
                                                message: 'Solo se permiten números enteros o con comas!',
                                            }
                                        ]}
                                    >
                                        <Input
                                            tabIndex={5}
                                            placeholder="Ej: 1000"
                                            style={{ height: '40px' }}
                                            onKeyPress={(event) => {
                                                const keyCode = event.which || event.keyCode;
                                                const char = String.fromCharCode(keyCode);
                                                const value = event.target.value;

                                                if (!/[0-9.]/.test(char) || (char === '.' && value.includes('.'))) {
                                                    event.preventDefault();
                                                }
                                            }}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name="longitud_carga"
                                        label={t('vehicle.longitud_carga')}
                                        rules={[{required: true, message: 'Por favor debe poner la longitud de carga!'},
                                            {
                                                pattern: /^\d+(\.\d+)?$/,
                                                message: 'Solo se permiten números enteros o con comas!',
                                            }]}
                                    >
                                        <Input
                                            tabIndex={7}
                                            placeholder="Ej: 4.0"
                                            style={{ height: '40px' }}
                                            onKeyPress={(event) => {
                                                const keyCode = event.which || event.keyCode;
                                                const char = String.fromCharCode(keyCode);
                                                const value = event.target.value;

                                                if (!/[0-9.]/.test(char) || (char === '.' && value.includes('.'))) {
                                                    event.preventDefault();
                                                }
                                            }}
                                        />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={8}>
                                    <Form.Item
                                        name="altura_carga"
                                        label={t('vehicle.altura_carga')}
                                        rules={[{required: true, message: 'Por favor debe poner la altura de carga!'},
                                            {
                                                pattern: /^\d+(\.\d+)?$/,
                                                message: 'Solo se permiten números enteros o con comas!',
                                            }]}
                                    >
                                        <Input
                                            tabIndex={8}
                                            placeholder="Ej: 2.2"
                                            style={{ height: '40px' }}
                                            onKeyPress={(event) => {
                                                const keyCode = event.which || event.keyCode;
                                                const char = String.fromCharCode(keyCode);
                                                const value = event.target.value;

                                                if (!/[0-9.]/.test(char) || (char === '.' && value.includes('.'))) {
                                                    event.preventDefault();
                                                }
                                            }}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                            </div>

                            {/* Operational Status Section */}
                            <div style={{
                                background: 'linear-gradient(135deg, #f8f9fc 0%, #e8ebf7 100%)',
                                borderRadius: '12px',
                                padding: '20px',
                                marginBottom: '24px',
                                border: '1px solid #e0e6ff'
                            }}>
                                <Title level={4} style={{
                                    color: '#253289',
                                    marginBottom: '16px',
                                    fontSize: '16px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                }}>
                                    ⚙️ {t('vehicle.estado_operativo')}
                                </Title>

                                <Row gutter={16}>
                                    <Col xs={24} sm={8}>
                                        <Form.Item
                                            name="idestadovehiculo"
                                            label={t('vehicle.estado')}
                                            rules={[{required: false, message: 'Por favor debe seleccionar el estado!'}]}
                                        >
                                            <GlobalSelect
                                                disabled={true}
                                                loading={spinning}
                                                valueName={'idestadovehiculo'}
                                                data={estadoVehiculo}
                                                tabIndex={9}
                                                style={{ height: '40px' }}
                                            />
                                        </Form.Item>
                                    </Col>

                                    <Col xs={24} sm={8}>
                                        <Form.Item
                                            name="idusuario"
                                            label={t('vehicle.repartidor')}
                                            rules={[{
                                                required: false,
                                                message: 'Por favor debe seleccionar el repartidor!'
                                            }]}
                                        >
                                            <GlobalSelect
                                                disabled={accion === "mod"}
                                                loading={spinning}
                                                valueName={'idusuario'}
                                                data={repartidor}
                                                tabIndex={10}
                                                style={{ height: '40px' }}
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </div>

                            {/* Comments Section */}
                            <div style={{
                                background: 'linear-gradient(135deg, #f8f9fc 0%, #e8ebf7 100%)',
                                borderRadius: '12px',
                                padding: '20px',
                                marginBottom: '24px',
                                border: '1px solid #e0e6ff'
                            }}>
                                <Title level={4} style={{
                                    color: '#253289',
                                    marginBottom: '16px',
                                    fontSize: '16px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                }}>
                                    💬 Comentarios y Observaciones
                                </Title>

                                <Form.Item
                                    name="comentarios"
                                    label={t('vehicle.comentarios')}
                                    rules={[{required: false, message: 'Por favor debe poner los comentarios!'}]}
                                >
                                    <Input.TextArea
                                        rows={3}
                                        tabIndex={11}
                                        placeholder="Observaciones adicionales sobre el vehículo..."
                                        style={{ borderRadius: '8px' }}
                                    />
                                </Form.Item>
                            </div>

                            {/* Action Buttons */}
                            <div style={{
                                textAlign: "center",
                                paddingTop: '16px',
                                borderTop: '1px solid #f0f0f0'
                            }}>
                                <Space size="middle">
                                    <Button
                                        icon={<CloseOutlined/>}
                                        danger
                                        onClick={cancelar}
                                        size="large"
                                        style={{
                                            height: '40px',
                                            paddingLeft: '24px',
                                            paddingRight: '24px',
                                            fontWeight: '500'
                                        }}
                                    >
                                        {t('global.cancel')}
                                    </Button>
                                    <Button
                                        icon={<SaveOutlined/>}
                                        type="primary"
                                        htmlType="submit"
                                        size="large"
                                        style={{
                                            background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                                            borderColor: '#253289',
                                            height: '40px',
                                            paddingLeft: '24px',
                                            paddingRight: '24px',
                                            fontWeight: '500',
                                            boxShadow: '0 2px 8px rgba(37, 50, 137, 0.3)'
                                        }}
                                    >
                                        {t('global.save')}
                                    </Button>
                                </Space>
                            </div>
                        </Form>
                    </Card>
                </div>
            </Spin>
        </div>
    );
};

export default FormAddVehiculo;
